import React from 'react'
import config from '../../../config.json'
import Translation from '../../Translation/cont/Translation'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import PageEventsPageOverlay from './PageEventsPageOverlay'
import SortableEventsListItem from './SortableEventsListItem'

const SortableEventsList = ({eventsStatus, eventsError, settingsData, settingsStatus, settingsError, activeSortId, sortSettings, sortedListItems, canDeleteEvent, displayOverlay, setDisplayOverlay, onSortList, onFetchEvents, onDeleteEvent}) => {
    const sortKeys = Object.keys(sortSettings)
    const sortKeysLength = sortKeys.length

    const overlay = <PageEventsPageOverlay
        eventsStatus={eventsStatus}
        eventsError={eventsError}
        settingsStatus={settingsStatus}
        settingsError={settingsError}
        displayOverlay={displayOverlay}
        setDisplayOverlay={setDisplayOverlay}
    />

    const gridColumnsStyle = {
        gridTemplateColumns: `15% 15% repeat(${sortKeysLength-2}, ${70 / (sortKeysLength-2)}%)`
    }

    return (
        <WrapperPageSimple pageTitleTransId={config.routes.events.transId} overlay={overlay}>
            <div className="events-page site-content site-event site-event-list">
                <button className="button fetch-button" onClick={() => onFetchEvents()}>
                    <span className="button-text">Events fetchen</span>
                </button>

                <div className="sortable-events-buttons sortable-events-data" style={gridColumnsStyle}>
                    {sortKeys.map(sortId => {
                        const settings = sortSettings[sortId]
                        const { name, reverse, sortable }  = settings
                        let buttonClass = 'sortable-events-button button'

                        if(activeSortId === sortId) {
                            buttonClass += reverse ? ' up' : ' down'
                        }

                        return (
                            sortable ? (
                                <button key={sortId} className={buttonClass} onClick={() => onSortList(sortId)}>
                                    <span className="title-large-light">{name}</span>
                                </button>
                            ) : (
                                <span key={sortId} className={buttonClass} >
                                    <span className="title-large-light">{name}</span>
                                </span>
                            )
                        )
                    })}
                </div>

                {sortedListItems ? (
                    <ul className="sortable-events-container">
                        {sortedListItems.map(item => {
                            const eventSettings = settingsData?.items?.[item.settings_id]
                            return (
                                <SortableEventsListItem
                                    key={item.id}
                                    event={item}
                                    eventSettings={eventSettings}
                                    sortSettings={sortSettings}
                                    gridColumnsStyle={gridColumnsStyle}
                                    canDeleteEvent={canDeleteEvent}
                                    onDeleteEvent={onDeleteEvent}
                                />
                            )
                        })}
                    </ul>
                ) : (
                    <div><Translation id="to_do">Keine Events gefunden</Translation></div>
                )}
            </div>
        </WrapperPageSimple>
    )
}

export default SortableEventsList